module.exports = __webpack_public_path__ + "img/sfz.cad0f866.png";